module.exports = __webpack_public_path__ + "static/img/HomePage2.b7a54ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/HomePage2.png
// module id = NwDx
// module chunks = 1